export class GroupSetting {
  public id: number;
  public g_name: string;
}



// WEBPACK FOOTER //
// /app/src/app/models/group-setting.ts